import { FC, useState } from 'react';
import styled from 'styled-components';
import { apiAssignWrestler } from '../ui_components/ApiList';
import type { WrestlerWithStats, User } from '../../types';

const ContainerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ModalContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  max-height: 95%;
  width: 70%;
  min-height: 50%;
  overflow-y: auto;
  background-color: white;
  color: #333;
  padding: 20px;
  border-radius: 5px;
  z-index: 1000;

  & .modal-footer-sp {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const WarningText = styled.div`
  background: #fff3cd;
  color: #856404;
  border: 1px solid #ffc107;
  border-radius: 6px;
  padding: 12px;
  margin-top: 12px;
  font-size: 14px;
  line-height: 1.5;
`;

interface ModalConfirmAssignWrestlerToUserProps {
  wrestlerData: WrestlerWithStats;
  user: User & { nickname_forum?: string };
  handleOpenModal: (reloadData?: boolean) => void;
}

interface AssignWrestlerError {
  message?: string;
}

const ModalConfirmAssignWrestlerToUser: FC<ModalConfirmAssignWrestlerToUserProps> = (props) => {
  const [isAssignLoading, setIsAssignLoading] = useState(false);
  const [isWrestlerAssignedError, setIsWrestlerAssignedError] = useState<AssignWrestlerError | null>(null);

  const assignButtonAction = async (): Promise<void> => {
    try {
      setIsAssignLoading(true);
      setIsWrestlerAssignedError(null);
      const responseAssignApi = await apiAssignWrestler({ wrestler_id: props.wrestlerData.id });

      if (responseAssignApi.success === false) {
        setIsWrestlerAssignedError({
          message: responseAssignApi.message || "Errore nell'assegnazione, riprovare.",
        });
        setIsAssignLoading(false);
      } else {
        props.handleOpenModal(true);
      }
    } catch (error) {
      console.error(error);
      setIsWrestlerAssignedError({
        message: "Errore nell'assegnazione, riprovare. Contattare un amministratore se l'errore persiste.",
      });
      setIsAssignLoading(false);
    }
  };

  const handleClose = (): void => {
    props.handleOpenModal(false);
  };

  return (
    <ContainerOverlay onClick={handleClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div className="modal-header-sp text-center">
          <h5>Seleziona {props.wrestlerData.name}</h5>
        </div>

        <div className="modal-body-sp text-center">
          <WarningText>
            Selezionando questo wrestler, confermi che è uno dei tuoi pg usati nel forum.
            Un admin ha libertà di rimuoverlo.
          </WarningText>
        </div>

        <div className="modal-footer-sp">
          <div>
            <button
              type="button"
              className="btn btn-danger mx-3"
              onClick={handleClose}
            >
              Chiudi
            </button>
            <button
              type="button"
              className="btn btn-success"
              disabled={isAssignLoading}
              onClick={assignButtonAction}
            >
              {isAssignLoading ? 'Caricamento...' : 'Conferma'}
            </button>
          </div>

          {isWrestlerAssignedError && (
            <p className="text-danger mt-2">
              {isWrestlerAssignedError.message}
            </p>
          )}
        </div>
      </ModalContent>
    </ContainerOverlay>
  );
};

export default ModalConfirmAssignWrestlerToUser;
